import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import type { Language } from '../../types/content';
import { focusRing } from '../../utils/styles';
interface LanguageToggleProps {
  className?: string;
}
const options: {
  id: Language;
  label: string;
  name: string;
}[] = [{
  id: 'en',
  label: 'EN',
  name: 'English'
}, {
  id: 'es',
  label: 'ES',
  name: 'Español'
}];
export function LanguageToggle({
  className = ''
}: LanguageToggleProps) {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div role="group" aria-label="Language / Idioma" className={`inline-flex rounded-full border border-mist bg-white p-1 ${className}`} data-id="element-184" data-mp="2t9f56r8kctv2">
      {options.map(o => {
      const active = lang === o.id;
      return <button key={o.id} type="button" lang={o.id} aria-pressed={active} aria-label={o.name} onClick={() => setLang(o.id)} className={`min-h-[36px] min-w-[44px] rounded-full px-3 text-sm font-bold transition-colors duration-150 ease-out ${focusRing} ${active ? 'bg-brand text-white' : 'text-ink-soft hover:text-brand'}`} data-id="element-185" data-mp="32ad0ml4xrt21">
            {o.label}
          </button>;
    })}
    </div>;
}